var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartHalfSideRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 291,
    viewBox: "0 0 415 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M182.264 291L100.011 291L-4.98945e-06 176.855L157.027 2.36537e-05L415 291L332.436 291L157.027 93.7119L82.5638 177.207L182.264 291Z",
    fill: "#F15924"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartHalfSideRight);
export default __webpack_public_path__ + "static/media/heart-half-side-right.88c7237c45a48249dae5564cd74b352c.svg";
export { ForwardRef as ReactComponent };